var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_139_5388",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_139_5388",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtklEQVRoge2YTUoDMRTHo4KgWI/gDcSdehARUdcuPYCCK6v1BgU/WnDhLVx4CXHhRp26EHQjfi7qezAD8TXpvMkkzXR4f/gtmmTC/9dOM7RKSSQSSZVyBHwD/chgh6aLQBXKZ3y5CMQuTSklECsiUEuBsTmdbAJVKM86nWwCsUtTSgnEigjUUmAaOAF6QAK00rEQCSLQInP9dCxEggj01KDAs4eyRbqxFtnGEzUo8OShbJFurEVFbqHjnCKTwDawCUwwiud1YC0a9iVGiUTxvsRYvqPttcfrPrQDa5GPYxTf7TbZ6xdYZV4fVcBUPuMemGfsEU0Ab5sLsscV8Ka97jD2GYnAIvAIPAC7wKyh/GkqtUHG12MLNIA7svbdUj5LV5t7BRZiClySdZRzUh4zp/5L3wBTMQR2DGX1p/SZoXyWFeBHW2s7WoMJLAGf2nw3HZ8BtoA1lf/A2teuR5nlUQngLXCrzeHt0Mgpawp+OtfaPqajtbCADT30hPFJ20WA8+NdDz1lfPLiItBkSND1HwHK454HLgK2lLrYU0SgNgJVoHDG5q9FWzin0yjADocuAhKJRBImfxuR5mlx3BaiAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.5113c41c86ae84699149ff09874273a4.svg";
export { ForwardRef as ReactComponent };